import axios, { AxiosInstance } from 'axios';
import { passkeyKey } from '../state/storageKey';
import { getUserToken } from '../state';
import {
  BtcCreateSendBtcPsbt,
  BtcSignPsbt,
  OnRampToken,
  SolSendTx,
  SwapResult,
} from './type';

export const successCode = 8000;
export const api: {
  index: AxiosInstance | undefined;
  bot: AxiosInstance | undefined;
  auth: AxiosInstance | undefined;
  tomo: AxiosInstance | undefined;
  pk: AxiosInstance | undefined;
  sun: AxiosInstance | undefined;
  init: (endpoints: [string], tmaid: string, tmakey: string) => void;
} = {
  index: undefined,
  bot: undefined,
  tomo: undefined,
  auth: undefined,
  pk: undefined,
  sun: undefined,
  init(endpoints: [string], tmaid, tmakey) {
    this.bot = axios.create({ baseURL: endpoints[0] + 'moon/' });
    this.auth = axios.create({ baseURL: endpoints[0] + 'wind/' });
    this.pk = axios.create({ baseURL: endpoints[0] + 'rain/' });
    this.sun = axios.create({ baseURL: endpoints[0] + 'sun/' });
    this.tomo = axios.create({
      baseURL: endpoints[0] + 'sky/api/',
    });

    [this.index, this.tomo, this.auth, this.bot, this.pk, this.sun].forEach(
      (apiItem: AxiosInstance | undefined) => {
        if (!apiItem) return;
        apiItem.interceptors.request.use(
          config => {
            // if (config.baseURL != endpoints[0] + 'bot-server/') {
            Object.defineProperty(config.headers, 'X-TOMO-TMA-USERID', {
              value: tmaid,
              writable: true,
              enumerable: true,
              configurable: true,
            });

            Object.defineProperty(config.headers, 'X-TOMO-TMA-KEY', {
              value: tmakey,
              writable: true,
              enumerable: true,
              configurable: true,
            });
            // }
            const passKey = getPassKey();

            if (passKey && config.baseURL === endpoints[0] + 'rain/') {
              config.headers.mfa = passKey;
            }
            const token = getUserToken();

            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
          },
          error => {
            if (error?.response?.status === 401) {
              return Promise.reject(error);
            }
            return null;
          }
        );
      }
    );
  },
};
export const getPassKey = () => {
  try {
    const token = localStorage.getItem(passkeyKey);
    return token ?? '';
  } catch (e) {
    return null;
  }
};

export const loginApi = async (initData: string) => {
  const res = await api.bot?.get(`login?${initData}`);
  return res?.data;
};

export const checkLoginByCodeApi = async (session_code: string) => {
  const res = await api.bot?.get(`session/token`, {
    headers: {
      'session-code': session_code,
    },
  });
  return res?.data;
};

export const pkRegApi = async (device_no: string) => {
  const res = await api.pk.post('v2/reg/' + device_no, {});
  return res?.data;
};

export const pkCreateApi = async (data: {
  device_no: string;
  pubkey: string;
}) => {
  const res = await api.auth.post('v2/passkey/create/', data);
  return res.data;
};
export const pkCheckApi = async (device_no: string) => {
  const res = await api.auth.get('v2/passkey/check/' + device_no);
  return res.data;
};

export const pkSignApi = async (data: {
  message: string;
  device_no: string;
}) => {
  const res = await api.pk.post('v2/sign', data);
  return res.data;
};

export const pkValidateApi = async (data: {
  device_no: string;
  message: string;
  sig: string;
}) => {
  const res = await api.auth.post('v2/passkey/validate/', data);
  return res.data;
};

export const btcSignPsbtAndPush = async (params: BtcSignPsbt) => {
  const { data } = await api.tomo.post(
    `socialLogin/projectWallet/bitcoin/signPsbtAndPush`,
    params
  );
  return data;
};

export const sendEvmTransactionApi = async (
  mfa: string,
  data: {
    transaction: { [key: string]: any };
    chainId: number;
    rpc: string;
  }
) => {
  const token = getUserToken();

  const res = await api.tomo.post(
    'socialLogin/projectWallet/ethereum/sendTransaction',
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        MFA: mfa,
      },
    }
  );
  return res.data;
};

export const tonSignMessage = async (
  mfa: string,
  data: { signingMessageBoc: string }
) => {
  const token = getUserToken();

  const res = await api.tomo.post(
    '/socialLogin/projectWallet/ton/signTransaction',
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        MFA: mfa,
      },
    }
  );
  return res.data;
};

export const solSignRawTransaction = async (params: SolSendTx) => {
  const { data } = await api.tomo.post(
    `socialLogin/projectWallet/solana/signRawTransaction`,
    params
  );
  return data;
};

// send BTC
export const btcCreateSendBtcPsbt = async (params: BtcCreateSendBtcPsbt) => {
  const { data } = await api.tomo.post(
    `socialLogin/projectWallet/bitcoin/createSendBitcoinPsbt`,
    params
  );
  return data;
};

export const btcSignMessage = async (params: any) => {
  const { data } = await api.tomo.post(
    `socialLogin/projectWallet/bitcoin/signMessage`,
    params
  );
  return data;
};

export const btcSignPsbt = async (params: BtcSignPsbt) => {
  const { data } = await api.tomo.post(
    `socialLogin/projectWallet/bitcoin/signPsbt`,
    params
  );
  return data;
};

export const decodeInfoByHex = async (params: any) => {
  const { data } = await api.tomo.post(
    `socialLogin/projectWallet/bitcoin/decode`,
    params
  );
  return data;
};

export const v2PkRegApi = async (device_no: string) => {
  const res = await api.pk.post('v2/reg/' + device_no, {});
  // console.log('apiRes', res)
  return res.data;
};

export const v2PkSignApi = async (data: {
  message: string;
  device_no: string;
}) => {
  const res = await api.pk.post('v2/sign', data);
  return res.data;
};

export const v2PkValidateApi = async (data: {
  device_no: string;
  message: string;
  sig: string;
}) => {
  const res = await api.auth.post('v2/passkey/validate/', data);
  return res.data;
};

export const v2PkCreateApi = async (data: {
  device_no: string;
  pubkey: string;
}) => {
  const res = await api.auth.post('v2/passkey/create/', data);
  return res.data;
};

export const v2PkCheckApi = async (device_no: string) => {
  const res = await api.auth.get('v2/passkey/check/' + device_no);
  return res.data;
};

export const checkPaymentPasswd = async () => {
  const res = await api.auth.get('v1/payment/passwd/check', {});
  return res.data;
};
export const setPaymentPasswd = async (data: { passwd: string }) => {
  const res = await api.auth.post('v1/payment/passwd/set', data);
  return res.data;
};
export const changePaymentPasswd = async (data: {
  old_passwd: string;
  new_passwd: string;
}) => {
  const res = await api.auth.post('v1/payment/passwd/change', data);
  return res.data;
};
export const validatePaymentPasswd = async (data: { passwd: string }) => {
  const res = await api.auth.post('v1/payment/passwd/validate', data);
  return res.data;
};
export const bindEmailCodeVerify = async (params: {
  email: string;
  code: string;
}) => {
  const { data } = await api.tomo.post(
    `socialLogin/projectUser/bindEmailCodeVerify`,
    params
  );
  return data;
};
export const bindEmailCodeSend = async (email: string) => {
  const { data } = await api.tomo.get(
    `socialLogin/projectUser/bindEmailCode?email=${email}`
  );
  return data;
};

export const getSwapAllTokens = async (): Promise<any> => {
  const ret = await api.tomo.get(`socialLogin/teleGram/wallet/tokens`, {});
  return ret.data;
};

export const getSwapAllTokensSearch = async (
  queryParameters: {
    content: string;
    chain?: string;
  },
  config: { url: string; tmaid: string; tmakey: string }
): Promise<any> => {
  const ret = await axios.get(`${config.url}wallet/tokens/search`, {
    params: queryParameters,
    headers: {
      'X-TOMO-TMA-USERID': config.tmaid,
      'X-TOMO-TMA-KEY': config.tmakey,
    },
  });
  return ret.data;
};

export const buildSwapTx = async (params: {
  fromChainid: number;
  toChainid: number;
  fromAddress: string;
  toAddress: string;
  amount: string;
  slippage: number;
  fromWalletAddress: string;
  toWalletAddress: string;
}): Promise<SwapResult> => {
  const ret = await api.sun.get(`v1/buildTx`, {
    params,
  });
  return ret.data.data;
};

export const getOnRampTokens = async (params: {
  evm_address: string;
  solana_address: string;
}): Promise<OnRampToken[]> => {
  const ret = await api.auth.get(`v1/token/balance`, { params });
  return ret.data.data;
};
